export default {
  app: {
    golf: {
      title: 'Platzinformationen',
      hasEVChargingPoint: 'EV-Ladestation',
      hasCaddieService: 'Caddie-Service',
      hasTrolley: 'Trolley',
      hasBuggy: 'Buggy',
      hasClubRental: 'Schlägerverleih',
      hasAcademy: 'Akademie',
      hasMarshal: 'Marshal',
      hasPGACertification: 'PGA-Zertifizierung',
      hasTrainingArea: 'Trainingsbereich',
      hasRestaurant: 'Restaurant',
      hasHotel: 'Hotel',
      hasDogsOnCourse: 'Hunde auf dem Platz',
      numberOfHoles: 'Anzahl der Löcher',
    },
  },
};
